import React, {Component} from 'react';

export class PageContent extends Component {
    render() {
        return (

            <div className="container registration-content-container">
                <h1 className="title-heading">Learn to code by watching others</h1>
                <p className="title-content-p">See how experienced developers solve problems in real-time. Watching
                    scripted
                    tutorials is great, but understanding how developers think is invaluable.</p>
            </div>

        );
    }
}

export default PageContent
